import { type SingleLineTextField } from '../../../types/graphql.form.ts'
import { type InputProps } from './index.tsx'
import Input from './input.tsx'

export default function InputSingleLineText({ field, error }: InputProps) {
	const singleLine = field as SingleLineTextField
	return (
		<Input
			type="text"
			name={singleLine.name}
			minLength={singleLine.singleLineMin}
			maxLength={singleLine.singleListMax}
			displayName={singleLine.displayName}
			placeholder={singleLine.placeholder}
			required={Boolean(singleLine.required)}
			defaultValue={singleLine.defaultValue}
			uid={singleLine.uid}
			visibility={singleLine.visibility}
			className="full"
			error={error}
			handle={singleLine.handle}
			labelPosition={field.labelPosition}
		/>
	)
}
